import { Document, HeadingLevel, Packer, Paragraph, TextRun } from 'docx';

export const downloadBriefDocx = async ({ title, sections, fileName }) => {
  const children = [
    new Paragraph({
      children: [new TextRun({ text: title, bold: true, size: 32 })],
      heading: HeadingLevel.HEADING_1,
      spacing: { after: 240 },
    }),
    ...sections.flatMap((section) => [
      new Paragraph({
        children: [new TextRun({ text: section.title, bold: true, size: 28 })],
        heading: HeadingLevel.HEADING_2,
        spacing: { before: 240, after: 120 },
      }),
      ...section.rows.map(
        (row) =>
          new Paragraph({
            children: [
              new TextRun({ text: `${row.label}: `, bold: true }),
              new TextRun({ text: row.value }),
            ],
            spacing: { after: 80 },
          }),
      ),
    ]),
  ];

  const doc = new Document({
    sections: [
      {
        properties: {},
        children,
      },
    ],
  });

  const blob = await Packer.toBlob(doc);
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
};
